import Typography from '../Typography';

import styled from 'styled-components';

import { ParagraphProps } from './types';
import { FC } from 'react';

const Paragraph = styled<FC<ParagraphProps>>(Typography.Paragraph)``;

export default Paragraph;
